import { render } from "./shopCategoryId.vue?vue&type=template&id=b3b04ece&scoped=true"
import script from "./shopCategoryId.vue?vue&type=script&lang=js"
export * from "./shopCategoryId.vue?vue&type=script&lang=js"

import "./shopCategoryId.vue?vue&type=style&index=0&id=b3b04ece&lang=scss&scoped=true"

import exportComponent from "/home/hulk-suman/Music/Insidejob-admin-devlopment-1/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b3b04ece"]])

export default __exports__